import { Component } from 'react';

type Props = {
};

type State = {
  downloadSpeed: number;
  uploadSpeed: number;
  complete: boolean;
  error: string | null;
};

class SpeedTest extends Component<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = {
      downloadSpeed: 0,
      uploadSpeed: 0,
      complete: false,
      error: null,
    };
  }

  bytesToMbps(bytesPerSec: number): number {
    return +(bytesPerSec * 8 /1_000_000).toFixed(2);
  }

  async download(): Promise<number> {
    const _url = "https://api.squaregolf.com/";

    const _ts = performance.now();

    const response = await fetch( _url, { cache: 'no-store' });
    const blob = await response.blob();
    const _te = performance.now();

    const duration = (_te - _ts) / 1000;
    const downloadSizeBytes = blob.size;

    return this.bytesToMbps(downloadSizeBytes / duration);
  }

  async upload(): Promise<number> {
    const _url = "https://api.squaregolf.com/";

    const uploadSizeBytes = 2_000_000;
    const blob = new Uint8Array(uploadSizeBytes);
    crypto.getRandomValues(blob);

    const _ts = performance.now();
    await fetch( _url, {
      method: 'POST',
      body: blob,
    });
    const _te = performance.now();

    const duration = (_te -_ts) / 1000;

    return this.bytesToMbps(uploadSizeBytes / duration);
  }

  async runSpeedTest() {
    this.setState({
      complete: false,
      error: null,
      downloadSpeed: 0,
      uploadSpeed: 0,
    });

    try {
      const downloadSpeed = await this.download();
      this.setState({ downloadSpeed: downloadSpeed });

      const uploadSpeed = await this.upload();
      this.setState({ uploadSpeed: uploadSpeed });
    } catch (err) {
      this.setState({ error: err as string });
    } finally {
      this.setState({ complete: true });
    }
  }

  render() {
    const { downloadSpeed, uploadSpeed, complete, error } = this.state;

    return (
      <>
        <div style={{ fontFamily: "Arial", padding: "20px" }}>
        <h2>Internet Speed Test</h2>
        <button onClick={() => this.runSpeedTest()} disabled={!complete}>
          {complete ? "Start Test" : "Testing..."}
        </button>

        {error && <p style={{ color: "red" }}>{error}</p>}

        {downloadSpeed !== null && (
          <p>Download Speed: {downloadSpeed} Mbps</p>
        )}
        {uploadSpeed !== null && (
          <p>Upload Speed: {uploadSpeed} Mbps</p>
        )}
      </div>
      </>
    );
  }
};

export default SpeedTest;